import React from 'react';
import { Container } from 'reactstrap';

export const PageContent = ({ children }) => (
	<Container fluid className="pl-4 pr-4 pl-sm-4 pr-sm-4 pl-md-5 pr-md-5 pl-lg-10 pr-lg-10 mt-0 mt-sm-3 mh-100 limit-height">
		{children}
	</Container>
);
